import { render, staticRenderFns } from "./ArticleContentHome.vue?vue&type=template&id=c56781e4&scoped=true"
import script from "./ArticleContentHome.vue?vue&type=script&lang=js"
export * from "./ArticleContentHome.vue?vue&type=script&lang=js"
import style0 from "./ArticleContentHome.vue?vue&type=style&index=0&id=c56781e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56781e4",
  null
  
)

export default component.exports